import * as React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * O ÚNICO estado de carregamento da plataforma.
 *
 * Havia três: `Skeleton` em 34 telas, spinner em 4 e o texto "Carregando…" em
 * 6 — três respostas diferentes para a mesma pergunta ("o app travou?"). O
 * spinner e o texto saíram; ficou o esqueleto, que é o único dos três que
 * mostra a FORMA do que está vindo, e por isso não faz a página pular quando o
 * dado chega.
 *
 * `variante` é a forma da tela, não o número de linhas:
 * - `tabela`  — cabeçalho + N linhas (arquétipos Índice, Cadastro, Relatório)
 * - `cards`   — grade de cards (listas em card no celular)
 * - `painel`  — faixa de KPIs + dois blocos (arquétipo Painel)
 */
export interface PageSkeletonProps {
  variante: "tabela" | "cards" | "painel";
  linhas?: number;
  className?: string;
}

export function PageSkeleton({ variante, linhas = 6, className }: PageSkeletonProps) {
  if (variante === "cards") {
    return (
      <div className={cn("space-y-2", className)} data-testid="page-skeleton">
        {Array.from({ length: linhas }).map((_, i) => (
          <Skeleton key={i} className="h-16 w-full" />
        ))}
      </div>
    );
  }

  if (variante === "painel") {
    return (
      <div className={cn("space-y-3", className)} data-testid="page-skeleton">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-20" />
          ))}
        </div>
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-48 w-full" />
      </div>
    );
  }

  return (
    <div className={cn("rounded-lg border bg-card overflow-hidden", className)} data-testid="page-skeleton">
      <div className="h-9 bg-muted/40 border-b" />
      <div className="divide-y">
        {Array.from({ length: linhas }).map((_, i) => (
          <div key={i} className="h-11 flex items-center px-3">
            <Skeleton className="h-3.5 w-full max-w-[420px]" />
          </div>
        ))}
      </div>
    </div>
  );
}
